import { useSelector } from 'react-redux';
import { getApplications } from '@app/common/store/profiles/selectors';
export function useIncludedTbaBuilds() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = useSelector(getApplications)
        .content.find(x => x.product === 'Toolbox')) === null || _a === void 0 ? void 0 : _a.include) === null || _b === void 0 ? void 0 : _b.map(x => x.build)) !== null && _c !== void 0 ? _c : []);
}
